<template>
  <svg
    class="size-4 lg:size-3"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 10C2.5 10.2652 2.60536 10.5196 2.79289 10.7071C2.98043 10.8946 3.23478 11 3.5 11H8.5C8.76522 11 9.01957 10.8946 9.20711 10.7071C9.39464 10.5196 9.5 10.2652 9.5 10V4H10.5V3H8.5V2C8.5 1.73478 8.39464 1.48043 8.20711 1.29289C8.01957 1.10536 7.76522 1 7.5 1H4.5C4.23478 1 3.98043 1.10536 3.79289 1.29289C3.60536 1.48043 3.5 1.73478 3.5 2V3H1.5V4H2.5V10ZM4.5 2H7.5V3H4.5V2ZM8.5 4V10H3.5V4H8.5Z"
      fill="var(--text-color)"
    ></path>
    <path
      d="M4.5 5H5.5V9H4.5V5ZM6.5 5H7.5V9H6.5V5Z"
      fill="var(--text-color)"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'IconDelete'
}
</script>


